import React, { } from 'react';
import {
    Col,
    Row,
    Modal,
    ModalHeader,
    ModalBody,
    Button,
} from "reactstrap";
import ToastHelper from '../../helpers/ToastHelper';
import { AvForm, AvField } from "availity-reactstrap-validation";
import { useMutation } from 'react-apollo';
import { withTranslation } from 'react-i18next';
import { connect } from "react-redux";
import { CREATE_ONE_CURRENCY } from '../../graphql/mutation/CREATE_ONE_CURRENCY';

function NewCurrency(props) {

    const { modal, toggleModal } = props;

    const [createOneCurrency] = useMutation(CREATE_ONE_CURRENCY);

    return (
        <React.Fragment>
            <Modal isOpen={modal} role="dialog" size="lg" autoFocus={true} centered={true} id="verificationModal" tabIndex="-1" toggle={toggleModal}>
                <div className="modal-content new-currency-page">
                    <ModalHeader toggle={toggleModal}>
                        Add Currency
                    </ModalHeader>
                    <ModalBody>
                        <div id="new-bank-wizard" className="twitter-bs-wizard">
                            <AvForm className="needs-validation"
                                onValidSubmit={async (event, values) => {
                                    await createOneCurrency({
                                        variables: {
                                            input: {
                                                currency: {
                                                    name: values.name,
                                                    code: values.code,
                                                    number: parseFloat(values.number.toString().replaceAll(',', '')),
                                                    symbol: values.symbol
                                                }
                                            }
                                        }
                                    }).catch(e => {
                                        ToastHelper.toggleToast({
                                            toastType: "error",
                                            message: e,
                                            title: "",
                                            onClick: function () { }
                                        })
                                    }).then(val => {
                                        if (val) {
                                            ToastHelper.toggleToast({
                                                message: "Create Succesfully!",
                                                title: "",
                                                onClick: function () { }
                                            })
                                            toggleModal()
                                        }
                                    })
                                }}
                            >
                                <Row>

                                    <Col lg={6}>
                                        <AvField
                                            label="Currency Code"
                                            name="code"
                                            type="text"
                                            placeholder="Enter Currency Code"
                                            errorMessage="Enter Currency Code"
                                            validate={{
                                                required: { value: true },
                                            }}
                                        />
                                    </Col>
                                    <Col lg={6}>
                                        <AvField
                                            label="Currency Number"
                                            name="number"
                                            type="text"
                                            placeholder="Enter Currency Number"
                                            errorMessage="Enter Currency Number"
                                            validate={{
                                                required: { value: true },
                                            }}
                                        />
                                    </Col>
                                    <Col lg={6}>
                                        <AvField
                                            label="Currency Name"
                                            name="name"
                                            type="text"
                                            placeholder="Enter Currency Name"
                                            errorMessage="Enter Currency Name"
                                            validate={{
                                                required: { value: true },
                                            }}
                                        />
                                    </Col>
                                    <Col lg={6}>
                                        <AvField
                                            label="Currency Symbol"
                                            name="symbol"
                                            type="text"
                                            placeholder="Enter Currency Symbol"
                                            errorMessage="Enter Currency Symbol"
                                            validate={{
                                                required: { value: true },
                                            }}
                                        />
                                    </Col>
                                </Row>
                                {
                                    <div className="action-container">
                                        <Button color="primary" type="submit">Submit</Button>
                                    </div>
                                }
                            </AvForm>
                        </div>
                    </ModalBody>
                </div>
            </Modal>
        </React.Fragment >
    );
}

export default connect()(withTranslation()(NewCurrency));